interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
  mode?: string;
}

export const headers: IHeaders[] = [
  {
    field: 'invoiceNumber',
    label: 'Invoice Number',
    type: 'text',
    op: 'cn',
    data: '',
  },
  // {
  // 	field: "",
  // 	label: "Revenue Service",
  // 	type: "text",
  // 	op: "cn",
  // 	data: "",
  // },
  {
    field: 'dateCreated',
    label: 'Date Created',
    type: 'date',
    op: 'eq',
    data: new Date(),
    mode: 'date',
  },
  // {
  // 	field: "amount",
  // 	label: "Invoice Amount",
  // 	type: "text",
  // 	op: "cn",
  // 	data: "",
  // },
];

export const headers1: IHeaders[] = [
  ...headers,
  {
    field: 'status',
    label: 'Invoice Status',
    type: 'select',
    op: 'eq',
    data: '',
    choices: [
      {
        optionId: 'PAID',
        optionName: 'PAID',
      },
      {
        optionId: 'UNPAID',
        optionName: 'UNPAID',
      },
      {
        optionId: 'CANCELLED',
        optionName: 'CANCELLED',
      },
    ],
  },
  {
    field: 'description',
    label: 'Invoice Description',
    type: 'text',
    op: 'cn',
    data: '',
  },
  {
    field: 'title',
    label: 'Invoice Title',
    type: 'text',
    op: 'cn',
    data: '',
  },
];
export const headers2: IHeaders[] = [
  ...headers,
  {
    field: 'status',
    label: 'Payment Status',
    type: 'select',
    op: 'eq',
    data: '',
    choices: [
      {
        optionId: 'CONFIRMED',
        optionName: 'CONFIRMED',
      },
      {
        optionId: 'APPROVAL_ONGOING',
        optionName: 'APPROVAL ONGOING',
      },
      {
        optionId: 'AWAITING_PAYMENT_CONFIRMATION',
        optionName: 'AWAITING PAYMENT CONFIRMATION',
      },
    ],
  },
  {
    field: 'description',
    label: 'Payment Description',
    type: 'text',
    op: 'cn',
    data: '',
  },
  {
    field: 'gatewayTransactionRefId',
    label: 'RRR',
    type: 'text',
    op: 'cn',
    data: '',
  },
];
